import axios from 'axios'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

const subscriptionKey = getEnv(Env.ApimProductWebSubscriptionKey)
const baseURL = getEnv(Env.WbacServiceUrl)

const service = axios.create({
  baseURL,
  params: { 'subscription-key': subscriptionKey },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default service
